'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _FooterPanel = require('./FooterPanel.css');

var _FooterPanel2 = _interopRequireDefault(_FooterPanel);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterPanel = (_dec = (0, _reactCssModules2.default)(_FooterPanel2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FooterPanel, _Component);

  function FooterPanel(props) {
    (0, _classCallCheck3.default)(this, FooterPanel);
    return (0, _possibleConstructorReturn3.default)(this, (FooterPanel.__proto__ || (0, _getPrototypeOf2.default)(FooterPanel)).call(this, props));
  }

  (0, _createClass3.default)(FooterPanel, [{
    key: 'render',
    value: function render() {
      // const dfwLogo = require( '../../../static/images/dfw_white.svg' )
      var aysLogo = require('../../../static/images/AsYouSow_Logo_color.svg');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'footer-wrap' },
          _react2.default.createElement(
            'div',
            { styleName: 'footer-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'footer-inner' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { styleName: 'footer-signup-wrap', xs: 12, sm: 12, md: 6, lg: 6 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'footer-signup-headline' },
                    'Support this work'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'footer-signup-tagline' },
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        'span',
                        { styleName: 'nowrap' },
                        'Tobacco Free Funds'
                      ),
                      ' is available to all users at no charge, funded by contributions to ',
                      _react2.default.createElement(
                        'span',
                        { styleName: 'nowrap' },
                        'As You Sow'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _.Link,
                    {
                      to: _config2.default.links.donate,
                      bigbutton: true,
                      title: 'Donate to As You Sow' },
                    'Donate ',
                    _react2.default.createElement('i', { className: 'fa fa-angle-double-right' })
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { styleName: 'footer-signup-wrap', xs: 12, sm: 12, md: 6, lg: 6 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'footer-signup-headline' },
                    'Get email updates'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'footer-signup-tagline' },
                    _react2.default.createElement(
                      'p',
                      null,
                      'We\'ll keep you up to date with the latest news from ',
                      _react2.default.createElement(
                        'span',
                        { styleName: 'nowrap' },
                        'As You Sow'
                      ),
                      ' and ',
                      _react2.default.createElement(
                        'span',
                        { styleName: 'nowrap' },
                        'Tobacco Free Funds'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _.Link,
                    {
                      to: _config2.default.links.signup,
                      bigbutton: true,
                      title: 'Sign up' },
                    'Sign up ',
                    _react2.default.createElement('i', { className: 'fa fa-angle-double-right' })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'double-logo' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'logo-first-wrap' },
                  _react2.default.createElement(
                    _.Link,
                    {
                      to: _config2.default.links.ays,
                      title: 'As You Sow'
                    },
                    _react2.default.createElement('img', {
                      styleName: 'logo-ays',
                      src: aysLogo,
                      alt: 'As You Sow'
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'footer-donate-tagline' },
                    'Empowering shareholders',
                    _react2.default.createElement('br', null),
                    'to change corporations for good'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'footer-social-icons-item' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'footer-social-label' },
                      'As You Sow'
                    ),
                    _react2.default.createElement(
                      _.Link,
                      {
                        to: _config2.default.links.socialAYSfb,
                        title: 'As You Sow Facebook' },
                      _react2.default.createElement('i', { styleName: 'footer-social-icon', className: 'fa fa-facebook-official' })
                    ),
                    _react2.default.createElement(
                      _.Link,
                      {
                        to: _config2.default.links.socialAYStwitter,
                        title: 'As You Sow Twitter' },
                      _react2.default.createElement('i', { styleName: 'footer-social-icon', className: 'fa fa-twitter' })
                    ),
                    _react2.default.createElement(
                      _.Link,
                      {
                        to: _config2.default.links.socialAYSinstagram,
                        title: 'As You Sow Instagram' },
                      _react2.default.createElement('i', { styleName: 'footer-social-icon', className: 'fa fa-instagram' })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'footer-disclaimer-links' },
                _react2.default.createElement(
                  _.Link,
                  {
                    to: _config2.default.routes.legal,
                    title: 'Legal' },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'white' },
                    'Legal'
                  )
                ),
                '\xA0\xA0|\xA0\xA0',
                _react2.default.createElement(
                  _.Link,
                  {
                    to: _config2.default.links.contact,
                    title: 'Contact' },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'white' },
                    'Contact'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'footer-disclaimer-text' },
                'Copyright \xA9 2018 As You Sow. As You Sow is not an investment advisor, nor do we provide financial planning, legal or tax advice. Nothing on this website shall constitute or be construed as an offering of financial instruments, or as investment advice or investment recommendations. ',
                _react2.default.createElement(
                  _.Link,
                  { to: _config2.default.routes.legal, title: 'Legal' },
                  ' ',
                  _react2.default.createElement(
                    'span',
                    { styleName: 'white' },
                    'See our full disclaimer ',
                    _react2.default.createElement('i', { className: 'fa fa-angle-double-right' })
                  ),
                  ' '
                )
              )
            )
          )
        )
      );
    }
  }]);
  return FooterPanel;
}(_react.Component), _class2.propTypes = {}, _temp)) || _class);
exports.default = FooterPanel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FooterPanel/FooterPanel.js
// module id = 1276
// module chunks = 0